module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Typeahead"
  }, [_c('div', {
    staticClass: "input-group  input-group-lg"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "companyclient-typeahead",
      "placeholder": "Auftraggeber suchen...",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        return _vm.down($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        return _vm.up($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.hit($event)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.reset($event)
      }],
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }, _vm.update]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [(_vm.acdIntervalId && _vm.isAcdKey()) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.stopAcdInterval
    }
  }, [_c('span', {
    staticClass: "glyphicon",
    class: {
      'glyphicon-pause': !_vm.loading, 'glyphicon-refresh': _vm.loading
    },
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.acdIntervalId && _vm.isAcdKey()) ? _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.startAcdInterval
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-play",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nothingFound),
      expression: "nothingFound"
    }],
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("Kein Auftraggeber gefunden / ausgewählt")]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasItems),
      expression: "hasItems"
    }]
  }, _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      class: _vm.activeClass(index),
      on: {
        "mousedown": _vm.hit,
        "mousemove": function($event) {
          return _vm.setActive(index)
        }
      }
    }, [_c('span', {
      staticClass: "name",
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(item.poolCallInNmber))
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "screen-name",
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(item.companyName))
      }
    })])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-search",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f886aabc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CompanyClientTypeahead.vue
// module id = 292
// module chunks = 0